import { useRef, useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { GoChevronDown, GoChevronUp } from "react-icons/go";
import { useTranslation } from "react-i18next";

const Dropdown = ({ options, placeholder, onChange, value }) => {
  const { t } = useTranslation("common");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    setIsOpen(false);
    if (onChange) onChange(option);
  };

  return (
    <div className="relative w-full text-sm font-jakarta" ref={dropdownRef}>
      <div
        className="flex items-center justify-between bg-ui-surface border border-ui-border rounded-lg p-2 cursor-pointer transition"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="text-ui-text">
          {value || placeholder || t("fields.selectOption")}
        </span>
        {isOpen ? (
          <GoChevronUp size={16} className="text-ui-text-muted" />
        ) : (
          <GoChevronDown size={16} className="text-ui-text-muted" />
        )}
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.ul
            initial={{ opacity: 0, y: -5 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -5 }}
            className="absolute pl-0 w-full mt-1 bg-ui-surface border border-ui-border rounded-lg max-h-40 overflow-auto z-10"
          >
            {options.length > 0 ? (
              options.map((option, index) => (
                <li
                  key={index}
                  className="p-2 hover:bg-brand-light cursor-pointer text-ui-text"
                  onClick={() => handleSelect(option)}
                >
                  {option}
                </li>
              ))
            ) : (
              <li className="p-2 text-text-muted text-center">
                {t("empty.noOptions")}
              </li>
            )}
          </motion.ul>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Dropdown;
